<template lang="html">


    <div class="wrapper margin-menu">
  
      <section class="intro column-center -colabora">
        <h2>Colabora</h2>
      </section>
  
      <section class="breadcrumb">
        <nav class="container row-end">
          <router-link to="/">Inicio</router-link>
          <router-link :to="$t('enlaces.colabora')">Colabora</router-link>
        </nav>
      </section>
  
      <main>

        <div class="contenedor-colabora container">
            <h2 class="big-title">Colabora</h2>
            <h3 class="title-intro">¿Te animas a <strong>colaborar</strong>?</h3>
            <proyecto-el :key="key" :project="project" v-for="(project,key) in projects"></proyecto-el>
        </div>


        <proyectos-finalizados></proyectos-finalizados>
  
  
      </main>
  
    </div>
  
  </template>
  
  <script lang="js">
  
     
  import proyecto from '@/components/parts/proyecto';

  import proyectosfinalizados from '@/components/parts/projects-finalizados';


import {mapGetters} from 'vuex'

export default {
  name: 'colabora',
  components : {
    'proyecto-el' : proyecto,
    'proyectos-finalizados' : proyectosfinalizados,
  },
  computed:{
    ...mapGetters({
      projects : 'getProjectsNotfinish'
    })
  }
}
    </script>
  


// WEBPACK FOOTER //
// src/components/views/colabora.vue